export default __webpack_public_path__ + "static/media/maleFemaleIcon.d5b25667.svg";